import DeviceFwuClient from './deviceFwuClient';
import fwuPackageService from './fwuPackageService';
import connectivityService from '../device/connectivityService';
import fwuTargetService from './fwuTargetService';
import SblFwuClient from './sblFwuClient';

const getFwuClient = (fwuTarget) => {
    const doesDeviceSupportSblUpdate = fwuPackageService.checkIfDeviceSupportsSblUpdate(fwuTarget);
    const isSblFirmwareType = fwuTargetService.isFwuTargetRequiresSblTypeUpdate(fwuTarget);
    const isUsb = connectivityService.isUsb();
    const isSblUpdate = isUsb || (doesDeviceSupportSblUpdate && isSblFirmwareType);
    const FwuClient = isSblUpdate ? SblFwuClient : DeviceFwuClient;

    return FwuClient;
};

export default {getFwuClient};
